import { Walkthrough } from "./types";
import walkthroughsData from "./walkthroughs.json";
import serviceBuilderPoster from "../../images/walkthrough-service-builder.jpg";
import logicBuilderPoster from "../../images/walkthrough-logic-builder.jpg";
import prescriptionPoster from "../../images/walkthrough-prescription.jpg";

/**
 * Poster stills, keyed by walkthrough id. These live here rather than in
 * `walkthroughs.json` because a JSON file can't `import` — going through
 * webpack keeps the content-hashed filename and the existing image convention.
 *
 * Without a poster the `<video>` has nothing to paint until it has downloaded
 * and decoded its own first frame, and these sources are 3420x2214 masters of
 * 84-179 MB — on a cold connection that leaves the cards black for tens of
 * seconds. A ~80 KB still shows instantly instead.
 */
const posters: Record<string, string> = {
  "service-builder-walkthrough": serviceBuilderPoster,
  "logic-builder-walkthrough": logicBuilderPoster,
  "prescription-bio-optimization-walkthrough": prescriptionPoster,
};

// JSON is untyped at the import boundary — assert the authored shape once here
// so the rest of the feature consumes a strongly-typed array.
export const walkthroughs: Walkthrough[] = (
  walkthroughsData as Walkthrough[]
).map((walkthrough) => ({
  ...walkthrough,
  thumbnail: posters[walkthrough.id] ?? walkthrough.thumbnail,
}));

export const getWalkthroughById = (id?: string): Walkthrough | undefined =>
  walkthroughs.find((w) => w.id === id);

/**
 * Source for a card's preview: a media-fragment URL that makes a muted
 * `<video>` render an early frame of the walkthrough's own video as its
 * still — so the listing preview matches what actually plays.
 */
export const getWalkthroughPreviewSrc = (walkthrough: Walkthrough): string =>
  `${walkthrough.videoUrl}#t=0.5`;

/** Format a minute count as the "12 min" label used in the duration badge. */
export const formatDuration = (minutes: number): string => `${minutes} min`;
